import { GlobalBannerContext } from './GlobalBanner.context';
import useGlobalBanner from './GlobalBanner.hook';
import { tGlobalBannerProviderProps } from './GlobalBanner.types';

export default function GlobalBannerProvider(props: tGlobalBannerProviderProps) {
  const value = useGlobalBanner();

  return (
    <GlobalBannerContext.Provider value={value}>
      {props.children}
    </GlobalBannerContext.Provider>
  );
}
